import { useParams, useNavigate } from "react-router-dom";
import "./RecoverPass.css";
import React, { useState } from 'react';
import { Box, Button, Stack, FormControl, TextField, Slide,Dialog,DialogTitle,DialogContent,DialogContentText,DialogActions } from "@mui/material";
import { validarEmail } from "global/util/validators";
import { Amplify } from 'aws-amplify';
import { resetPassword } from 'aws-amplify/auth';
import CircularProgress from '@mui/material/CircularProgress'; 
import { TransitionProps } from '@mui/material/transitions';
import { Link } from "react-router-dom";
import { postJson } from 'api/httpClient';

import awsconfig from 'aws-config';
//Amplify.configure(awsconfig);

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Transition = React.forwardRef(function Transition(
	props: TransitionProps & {
		children: React.ReactElement<any, any>;
	},
	ref: React.Ref<unknown>,
) {
	return <Slide direction="up" ref={ref} {...props} />;
});

export const RecoverPass = () => {


	const [email, setEmail] = useState('');
	const [firstTry, setFirstTry] = useState(false);
	const [loginError, setLoginError] = useState('');
	const [loading, setLoading] = useState(false);
	const [reseted, setReseted] = useState(false);
	const navigate = useNavigate()

	const handlePasswordRecovery = async () => {
		setLoading(true);
		try{
			await postJson<any>(`${API_BASE_URL}/reset-password`, {email:email})
            console.log("password reset");
                
			setLoginError('');
			setReseted(true);
		}catch(error){
			console.error("no se pudo resetear password",error);
			setLoginError(processForgotPasswordError(error));
		}finally{
			setLoading(false);
		}
		
	};
	const processForgotPasswordError = (error: any): string => {
		switch (error.code) {
		  case 'UserNotFoundException':
			return 'No se encontró un usuario con esa dirección de correo electrónico.';
		  case 'LimitExceededException':
			return 'Has excedido el límite de intentos. Por favor, espera un momento antes de intentar nuevamente.';
		  default:
			return 'Ha ocurrido un error inesperado. Por favor, intenta nuevamente.';
		}
	  };
	
	const handleCloseModal = () => {
        setReseted(false);
		//navigate(`/`);
    };

	return (
		<Box
				className="home-component"
				sx={{ width: 400, marginTop: 3, marginBottom: 5}}
			>
				<div className="password-recovery-container">
					<h2>Olvidaste tu contraseña?</h2>
					<FormControl fullWidth sx={{ mt: 1, mb: 1 }} variant="outlined">
                        <label className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-outlined MuiFormLabel-colorPrimary MuiFormLabel-filled MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiInputLabel-outlined css-1jy569b-MuiFormLabel-root-MuiInputLabel-root" >
                            Ingresa el correo electr&oacute;nico con el cual te registraste:
                        </label>
                    </FormControl>
					<TextField error={firstTry && !validarEmail(email)} onBlur={() => setFirstTry(true)} fullWidth sx={{ mt: 1, mb: 1 }} id="outlined-basic" label="Correo electrónico" type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
					{
						loginError === '' ?
							<></> :
							<p style={{ color: "red" }}>*{loginError}</p>
					}
					<Stack spacing={1} direction="row" justifyContent="center" marginTop={2}>
						<Button disabled={loading} variant="contained" onClick={handlePasswordRecovery} className="app-primary-button" >
							{loading ? <CircularProgress size={24} color="inherit" /> : "Enviar instrucciones"}
						</Button>
					</Stack>
				</div>

				<Dialog
                    open={reseted}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={handleCloseModal}
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle>{"Correo enviado correctamente"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                            Hemos enviado un enlace de confirmaci&oacute;n a tu correo electr&oacute;nico para terminar de restaurar tu contraseña.<br></br>
							Si no recibes nuestro correo, revisa tu casilla de spam.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Link to={`/login`} onClick={handleCloseModal}>
                            <Button>Aceptar</Button>
                        </Link>
                    </DialogActions>

                </Dialog>
		</Box>
	);
};
